import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import './DraggableFormComponent.css';
import WangEditor from './components/WangEditor';

export default function DraggableFormComponent({ id, index, type, data, moveComponent, onSelect, onRemove, isPreviewMode, selectedComponent }) {
  const ref = React.useRef(null);

  const [, drop] = useDrop({
    accept: 'form-component',
    hover(item) {
      if (!moveComponent || item.index === index) return;
      moveComponent(item.index, index);
      item.index = index;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'form-component',
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  if (!isPreviewMode) {
    drag(drop(ref));
  }

  // 通用输入框样式
  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #d9d9d9',
    borderRadius: '6px',
    fontSize: '14px',
    backgroundColor: isPreviewMode ? '#fff' : '#fafafa',
    color: isPreviewMode ? '#333' : '#666',
    outline: 'none',
    transition: 'all 0.2s'
  };

  // 渲染不同类型组件
  let content = null;
  switch (type) {
    case 'input':
    case 'member_name':
    case 'member_phone':
      content = <input className="form-input" placeholder={data.props?.placeholder || "请输入文本"} disabled={!isPreviewMode} />;
      break;
    case 'member_community':
      content = (
        <input
          className="form-input"
          placeholder={data.props?.placeholder || "请输入小区"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'textarea':
      content = <textarea className="form-textarea" placeholder={data.props?.placeholder || "请输入多行文本"} disabled={!isPreviewMode} />;
      break;
    case 'number':
      content = <input className="form-input" type="number" placeholder={data.props?.placeholder || "请输入数字"} disabled={!isPreviewMode} />;
      break;
    case 'password':
      content = <input className="form-input" type="password" placeholder={data.props?.placeholder || "请输入密码"} disabled={!isPreviewMode} />;
      break;
    case 'email':
      content = <input className="form-input" type="email" placeholder={data.props?.placeholder || "请输入邮箱地址"} disabled={!isPreviewMode} />;
      break;
    case 'select':
      if (data.props?.layoutType === 'inline') {
        content = (
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {data.props?.options?.map((option, index) => (
              <button
                key={index}
                type="button"
                className="form-select-inline-btn"
                style={{
                  padding: '8px 18px',
                  border: '1.5px solid #d9d9d9',
                  borderRadius: '6px',
                  background: '#fff',
                  color: '#222',
                  fontSize: '15px',
                  cursor: isPreviewMode ? 'pointer' : 'not-allowed',
                  opacity: isPreviewMode ? 1 : 0.6
                }}
                disabled={!isPreviewMode}
              >
                {option}
              </button>
            ))}
          </div>
        );
      } else {
        content = (
          <select className="form-select" disabled={!isPreviewMode}>
            <option>{data.props?.placeholder || "请选择选项"}</option>
            {data.props?.options?.map((option, index) => (
              <option key={index}>{option}</option>
            ))}
          </select>
        );
      }
      break;
    case 'radio':
      if (data.props?.layoutType === 'dropdown') {
        content = (
          <select className="form-select" disabled={!isPreviewMode}>
            <option>{data.props?.placeholder || "请选择选项"}</option>
            {data.props?.options?.map((option, index) => (
              <option key={index}>{option}</option>
            ))}
          </select>
        );
      } else {
        content = (
          <div className={data.props?.layoutType === 'inline' ? 'radio-group radio-group-inline' : 'radio-group'}>
            {data.props?.options?.map((option, index) => (
              <label key={index} className="radio-option">
                <input
                  type="radio"
                  name={`radio_${id}`}
                  value={option}
                  checked={data.value === option}
                  disabled={!isPreviewMode}
                  onChange={() => {
                    if (isPreviewMode && onSelect) {
                      onSelect({ ...data, value: option });
                    }
                  }}
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        );
      }
      break;
    case 'checkbox':
      if (data.props?.layoutType === 'dropdown') {
        content = (
          <div style={{ position: 'relative' }}>
            <div
              className="form-select"
              style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: isPreviewMode ? 'pointer' : 'not-allowed' }}
            >
              <span>{data.props?.placeholder || "请选择选项"}</span>
              <span style={{ fontSize: '12px', color: isPreviewMode ? '#999' : '#ccc' }}>▼</span>
            </div>
            {isPreviewMode && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#fff',
                  border: '1px solid #d9d9d9',
                  borderTop: 'none',
                  borderRadius: '0 0 6px 6px',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  zIndex: 1000,
                  display: 'none'
                }}
              >
                {data.props?.options?.map((option, index) => (
                  <div
                    key={index}
                    style={{
                      padding: '8px 12px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      borderBottom: index < data.props.options.length - 1 ? '1px solid #f0f0f0' : 'none'
                    }}
                  >
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '1px solid #d9d9d9',
                        borderRadius: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#fff'
                      }}
                    >
                    </div>
                    <span style={{ flex: 1 }}>{option}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      } else {
        content = (
          <div className={data.props?.layoutType === 'inline' ? 'checkbox-group checkbox-group-inline' : 'checkbox-group'}>
            {data.props?.options?.map((option, index) => (
              <label key={index} className="checkbox-option">
                <input type="checkbox" disabled={!isPreviewMode} />
                <span>{option}</span>
              </label>
            ))}
          </div>
        );
      }
      break;
    case 'switch':
      content = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ 
            width: '44px', 
            height: '24px', 
            background: data.props?.checked ? '#1890ff' : '#d9d9d9', 
            borderRadius: '12px', 
            position: 'relative',
            cursor: 'not-allowed'
          }}>
            <div style={{ 
              width: '20px', 
              height: '20px', 
              background: '#fff', 
              borderRadius: '50%', 
              position: 'absolute', 
              top: '2px', 
              left: data.props?.checked ? '22px' : '2px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'left 0.2s'
            }}></div>
          </div>
          <span style={{ color: '#666', fontSize: '14px' }}>开关状态</span>
        </div>
      );
      break;
    case 'image':
      content = (
        <div style={{ 
          border: '2px dashed #d9d9d9', 
          borderRadius: '8px', 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#fafafa'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🖼️</div>
          <div style={{ color: '#666', fontSize: '14px' }}>点击选择图片</div>
        </div>
      );
      break;
    case 'image-multi':
      content = (
        <div style={{ 
          border: '2px dashed #d9d9d9', 
          borderRadius: '8px', 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#fafafa'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🖼️🖼️</div>
          <div style={{ color: '#666', fontSize: '14px' }}>点击选择多张图片</div>
        </div>
      );
      break;
    case 'date':
      content = <input className="form-input" type="date" disabled={!isPreviewMode} />;
      break;
    case 'time':
      content = <input className="form-input" type="time" disabled={!isPreviewMode} />;
      break;
    case 'datetime':
      content = <input className="form-input" type="datetime-local" disabled={!isPreviewMode} />;
      break;
    case 'rate':
      content = (
        <div style={{ display: 'flex', gap: '4px' }}>
          {Array.from({ length: data.props?.max || 5 }, (_, i) => (
            <span key={i} style={{ fontSize: '20px', color: i < (data.props?.value || 0) ? '#ffd700' : '#d9d9d9' }}>⭐</span>
          ))}
        </div>
      );
      break;
    case 'slider':
      content = (
        <div style={{ padding: '10px 0' }}>
          <input 
            type="range" 
            min={data.props?.min || 0} 
            max={data.props?.max || 100} 
            defaultValue={data.props?.value || 50}
            disabled={!isPreviewMode}
            style={{
              width: '100%',
              height: '6px',
              borderRadius: '3px',
              background: '#d9d9d9',
              outline: 'none'
            }}
          />
          <div style={{ textAlign: 'center', marginTop: '8px', color: '#666', fontSize: '14px' }}>
            当前值: {data.props?.value || 50}
          </div>
        </div>
      );
      break;
    case 'upload':
      content = (
        <div style={{ 
          border: '2px dashed #d9d9d9', 
          borderRadius: '8px', 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#fafafa'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>📁</div>
          <div style={{ color: '#666', fontSize: '14px' }}>点击上传文件</div>
        </div>
      );
      break;
    case 'video':
      content = (
        <div style={{ 
          border: '2px dashed #d9d9d9', 
          borderRadius: '8px', 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#fafafa'
        }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🎥</div>
          <div style={{ color: '#666', fontSize: '14px' }}>点击上传视频</div>
        </div>
      );
      break;
    case 'richtext':
      content = isPreviewMode ? (
        <div
          style={{ border: '1px solid #d9d9d9', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa', minHeight: '100px' }}
          dangerouslySetInnerHTML={{ __html: data.props?.value || '' }}
        />
      ) : (
        <WangEditor
          value={data.props?.value || ''}
          onChange={val => onSelect && onSelect({ ...data, props: { ...data.props, value: val } })}
        />
      );
      break;
    case 'signature':
      content = (
        <div style={{ 
          border: '1px solid #d9d9d9', 
          borderRadius: '6px', 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#fafafa',
          minHeight: '80px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ color: '#666', fontSize: '14px' }}>✍️ 点击此处签名</div>
        </div>
      );
      break;
    case 'divider':
      content = (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          margin: '16px 0',
          color: '#999'
        }}>
          <div style={{ flex: 1, height: '1px', background: '#e8e8e8' }}></div>
          <span style={{ padding: '0 12px', fontSize: '12px' }}>{data.props?.text || '分割线'}</span>
          <div style={{ flex: 1, height: '1px', background: '#e8e8e8' }}></div>
        </div>
      );
      break;
    case 'title':
      content = (
        <div style={{ 
          padding: '16px 0',
          borderBottom: '2px solid #1890ff',
          marginBottom: '8px'
        }}>
          <h3 style={{ margin: 0, color: '#333', fontSize: '18px', fontWeight: '600' }}>{data.props?.text || '标题'}</h3>
        </div>
      );
      break;
    case 'description':
      content = (
        <div style={{ 
          padding: '12px 16px',
          background: '#f6ffed',
          border: '1px solid #b7eb8f',
          borderRadius: '6px',
          borderLeft: '4px solid #52c41a'
        }}>
          <p style={{ margin: 0, color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
            💡 {data.props?.text || '这是一段说明文字，用于向用户解释相关信息。'}
          </p>
        </div>
      );
      break;
    case 'member_brand_merchant':
      content = (
        <div className="form-select" style={{ 
          minHeight: '40px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          cursor: isPreviewMode ? 'pointer' : 'not-allowed',
          backgroundColor: isPreviewMode ? '#fff' : '#f5f5f5'
        }}>
          <span style={{ color: '#999' }}>{data.props?.placeholder || "请选择品牌商家"}</span>
          <span style={{ fontSize: '12px', color: isPreviewMode ? '#999' : '#ccc' }}>🔍</span>
        </div>
      );
      break;
    case 'building_number':
      content = (
        <input 
          className="form-input" 
          type="text"
          placeholder={data.props?.placeholder || "请输入楼号"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'house_area':
      content = (
        <input 
          className="form-input" 
          type="number"
          placeholder={data.props?.placeholder || "请输入房屋面积"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'vip_card_number':
      content = (
        <input 
          className="form-input" 
          type="text"
          placeholder={data.props?.placeholder || "请输入特权黑卡号"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'inspection_time':
      const inspectionInputType = data.props?.allowTime ? 'datetime-local' : 'date';
      content = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '14px', color: '#333', minWidth: '60px' }}>考察时间:</span>
          <input 
            className="form-input" 
            type={inspectionInputType}
            defaultValue={data.defaultValue || ''}
            disabled={!isPreviewMode}
            style={{ flex: 1 }}
          />
        </div>
      );
      break;
    case 'activity_time':
      const inputType = data.props?.allowTime ? 'datetime-local' : 'date';
      content = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '14px', color: '#333', minWidth: '60px' }}>活动时间:</span>
          <input 
            className="form-input" 
            type={inputType}
            defaultValue={data.defaultValue || ''}
            disabled={!isPreviewMode}
            style={{ flex: 1 }}
          />
        </div>
      );
      break;
    case 'inspection_brand':
      content = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ fontSize: '14px', color: '#333', marginBottom: '4px' }}>品牌:</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {(data.props?.options || []).slice(0, 4).map((opt, idx) => (
              <div key={idx} style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '6px',
                padding: '6px 12px',
                background: '#f8f9fa',
                borderRadius: '6px',
                fontSize: '12px',
                color: '#666'
              }}>
                <input 
                  type="radio" 
                  name={`preview_${id}`} 
                  disabled={!isPreviewMode}
                  style={{ width: '14px', height: '14px' }}
                />
                <span>{opt}</span>
              </div>
            ))}
            {(data.props?.options || []).length > 4 && (
              <div style={{ 
                padding: '6px 12px',
                background: '#f0f0f0',
                borderRadius: '6px',
                fontSize: '12px',
                color: '#999'
              }}>
                +{(data.props?.options || []).length - 4}个选项
              </div>
            )}
          </div>
        </div>
      );
      break;
    case 'inspection_community':
      content = (
        <input
          className="form-input"
          placeholder={data.props?.placeholder || "请输入验房小区"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'inspection_datetime':
      content = (
        <input
          className="form-input"
          type="datetime-local"
          placeholder={data.props?.placeholder || "请选择验房时间"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'inspection_remark':
    case 'activity_requirement':
      content = (
        <textarea
          className="form-textarea"
          placeholder={data.props?.placeholder || "请输入内容"}
          disabled={!isPreviewMode}
          style={{ width: '100%', minHeight: 60, resize: 'vertical' }}
        />
      );
      break;
    case 'shop_address':
      content = (
        <input
          className="form-input"
          placeholder={data.props?.placeholder || "请输入店铺地址"}
          disabled={!isPreviewMode}
          style={{ width: '100%' }}
        />
      );
      break;
    case 'activity_brand':
      // 复用inspection_brand的渲染逻辑
      content = (() => {
        const options = data.props?.options || [];
        if (options.length === 0) {
          return (
            <div style={{
              padding: '12px',
              background: '#fff2e8',
              border: '1px solid #ffbb96',
              borderRadius: '8px',
              color: '#d46b08',
              fontSize: '14px',
              textAlign: 'center'
            }}>
              活动品牌组件：暂无选项，请在属性面板中添加选项
            </div>
          );
        }
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {options.map((opt, idx) => {
              const optionValue = typeof opt === 'object' ? opt.name : opt;
              const isChecked = data.value === optionValue;
              return (
                <div
                  key={typeof opt === 'object' ? opt.id || opt.name : idx}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 16px',
                    background: isChecked ? '#e6f7ff' : '#f8f9fa',
                    borderRadius: '10px',
                    cursor: isPreviewMode ? 'pointer' : 'not-allowed',
                    border: isChecked ? '2px solid #667eea' : '2px solid transparent',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <div
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #667eea',
                      background: isChecked ? '#667eea' : 'transparent',
                      position: 'relative',
                      cursor: 'pointer'
                    }}
                  >
                    {isChecked && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          background: '#fff'
                        }}
                      />
                    )}
                  </div>
                  <span style={{ fontSize: '16px', color: '#333' }}>{optionValue}</span>
                </div>
              );
            })}
          </div>
        );
      })();
      break;
    case 'activity_brand_multi': {
      const options = data.props?.options || [];
      const valueArr = (data.value || '').split(',').filter(Boolean);
      content = (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', flexWrap: 'wrap' }}>
          {options.length === 0 ? (
            <div style={{
              padding: '12px',
              background: '#fff2e8',
              border: '1px solid #ffbb96',
              borderRadius: '8px',
              color: '#d46b08',
              fontSize: '14px',
              textAlign: 'center'
            }}>
              品牌多选组件：暂无选项，请在属性面板中添加选项
            </div>
          ) : options.map((opt, idx) => {
            const optionValue = typeof opt === 'object' ? opt.name : opt;
            const isChecked = valueArr.includes(optionValue);
            return (
              <div 
                key={optionValue || idx} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 8, 
                  cursor: isPreviewMode ? 'pointer' : 'not-allowed', 
                  background: isChecked ? '#1890ff' : '#f8f9fa', 
                  borderRadius: 6, 
                  padding: '8px 12px', 
                  border: isChecked ? '2px solid #1890ff' : '2px solid transparent', 
                  transition: 'all 0.2s',
                  minWidth: 'fit-content'
                }}
                onClick={() => {
                  if (!isPreviewMode) return;
                  let newArr = valueArr.slice();
                  if (isChecked) {
                    newArr = newArr.filter(v => v !== optionValue);
                  } else {
                    newArr.push(optionValue);
                  }
                  if (onSelect) onSelect({ ...data, value: newArr.join(',') });
                }}
              >
                <span style={{ fontSize: '15px', color: isChecked ? '#fff' : '#333' }}>{optionValue}</span>
              </div>
            );
          })}
        </div>
      );
      break;
    }
    case 'brand_store_cascader': {
      // 级联选择器：品牌-店铺地址
      const mapping = data.props?.mapping || [];
      const selectedBrand = data.value?.brand || '';
      const selectedStore = data.value?.store || '';
      const brands = mapping.map(item => (typeof item === 'object' ? item.brand : item));
      const stores = mapping.find(item => (typeof item === 'object' ? item.brand : item) === selectedBrand)?.stores || [];
      content = (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', width: '100%' }}>
          <select
            value={selectedBrand}
            onChange={e => isPreviewMode && onSelect && onSelect({ ...data, value: { brand: e.target.value, store: '' } })}
            style={{ ...inputStyle, flex: 1 }}
            disabled={!isPreviewMode}
          >
            <option value="">请选择品牌商家</option>
            {brands.map((brand, idx) => (
              <option key={idx} value={brand}>{brand}</option>
            ))}
          </select>
          <select
            value={selectedStore}
            onChange={e => isPreviewMode && onSelect && onSelect({ ...data, value: { brand: selectedBrand, store: e.target.value } })}
            style={{ ...inputStyle, flex: 1 }}
            disabled={!selectedBrand || !isPreviewMode}
          >
            <option value="">请选择店铺地址</option>
            {stores.map((store, idx) => (
              <option key={idx} value={store}>{store}</option>
            ))}
          </select>
        </div>
      );
      break;
    }
    default:
      content = <div style={{ color: '#999', textAlign: 'center', padding: '20px' }}>未知组件类型</div>;
  }

  return (
    <div
      ref={ref}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: isPreviewMode ? 'default' : 'pointer',
        position: 'relative',
        marginBottom: '16px',
        padding: '16px',
        border: selectedComponent?.id === id ? '2px solid #1890ff' : '1px solid #e8e8e8',
        borderRadius: '8px',
        backgroundColor: selectedComponent?.id === id ? '#f0f8ff' : '#fff',
        transition: 'all 0.2s',
        display: data.hidden && isPreviewMode ? 'none' : 'block'
      }}
      onClick={() => !isPreviewMode && onSelect({ id, type, ...data })}
    >
      {/* 字段标签区：字段名、必填、隐藏并排显示 */}
      <div style={{
        position: 'absolute',
        top: '-8px',
        left: '12px',
        display: 'flex',
        gap: '6px',
        zIndex: 1
      }}>
        {data.label && (
          <span style={{
            backgroundColor: '#1890ff',
            color: '#fff',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500'
          }}>{data.label}</span>
        )}
        {data.required && (
          <span style={{
            backgroundColor: '#ff7875',
            color: '#fff',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500'
          }}>必填</span>
        )}
        {data.hidden && (
          <span style={{
            backgroundColor: '#ff7875',
            color: '#fff',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500'
          }}>隐藏</span>
        )}
      </div>
      
      {/*/!* 隐藏字段标识 *!/*/}
      {/*{data.hidden && !isPreviewMode && (*/}
      {/*  <div style={{*/}
      {/*    position: 'absolute',*/}
      {/*    top: '-8px',*/}
      {/*    right: '19px',*/}
      {/*    backgroundColor: '#ff7875',*/}
      {/*    color: '#fff',*/}
      {/*    padding: '2px 8px',*/}
      {/*    borderRadius: '4px',*/}
      {/*    fontSize: '12px',*/}
      {/*    fontWeight: '500',*/}
      {/*    zIndex: 1*/}
      {/*  }}>*/}
      {/*    隐藏*/}
      {/*  </div>*/}
      {/*)}*/}
      
      {/*/!* 必填标识 *!/*/}
      {/*{data.required && (*/}
      {/*  <div style={{*/}
      {/*    position: 'absolute',*/}
      {/*    top: '-8px',*/}
      {/*    left: data.fieldName ? (data.hidden ? '140px' : '80px') : '-2px',*/}
      {/*    backgroundColor: '#ff7875',*/}
      {/*    color: '#fff',*/}
      {/*    padding: '2px 8px',*/}
      {/*    borderRadius: '4px',*/}
      {/*    fontSize: '12px',*/}
      {/*    fontWeight: '500',*/}
      {/*    zIndex: 1*/}
      {/*  }}>*/}
      {/*    必填*/}
      {/*  </div>*/}
      {/*)}*/}

      {/* 组件内容 */}
      <div style={{ marginTop: data.fieldMap ? '8px' : '0' }}>
        {content}
      </div>

      {/* 删除按钮 */}
      {!isPreviewMode && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove(id);
          }}
          style={{
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            background: 'none',
            color: '#ff4757',
            border: 'none',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2
          }}
          title="删除组件"
        >
          🗑️
        </button>
      )}
    </div>
  );
} 